export const _davMimeTypes = ["video/dav"];
